"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProjectStatus = props => {
  const {
    projectStatus,
    setProjectStatus
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "project-status c-paper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-status__head"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Changer le status du projet ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-status__body"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: projectStatus === "open" ? 'project-status__select active-open' : 'project-status__select',
    onClick: () => setProjectStatus("open")
  }, "Ouvert"), /*#__PURE__*/_react.default.createElement("button", {
    className: projectStatus === "running" ? 'project-status__select active-running' : 'project-status__select',
    onClick: () => setProjectStatus("running")
  }, "En cours"), /*#__PURE__*/_react.default.createElement("button", {
    className: projectStatus === "pending" ? 'project-status__select active-pending' : 'project-status__select',
    onClick: () => setProjectStatus("pending")
  }, "En attente"), /*#__PURE__*/_react.default.createElement("button", {
    className: projectStatus === "over" ? 'project-status__select active-over' : 'project-status__select',
    onClick: () => setProjectStatus("over")
  }, "Termin\xE9")));
};
var _default = exports.default = ProjectStatus;
